import React from 'react';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import apiClient from '../../../../Services/ApiClient';
import useApiClient from '../../../Base/Hooks/useApiClient';
import useNotification from '../../../../Hooks/useNotification.hook';
import useTranslation from '../../../../Hooks/useTranslation';
import usePatientConsent from '../../../../Components/PatientProfile/Hooks/usePatientConsent';
import { usePatientTreatmentContext } from '../PatientTreatment/ContextProvider';

interface Props {
	patientId: string;
	setIsLoading: (isLoading: boolean) => void;
}

const PatientConsentRequestButton: React.FC<Props> = ({
	patientId,
	setIsLoading,
}) => {
	const { displayError } = useApiClient();
	const { showNotificationSuccess } = useNotification();
	const { t } = useTranslation();
	const { isConsentProvided } = usePatientConsent(patientId);
	const { caseId } = usePatientTreatmentContext();
	const handleAskForPermission = async () => {
		setIsLoading(true);
		try {
			const result = await apiClient.post(`/user/${patientId}/consent`, {
				caseId,
			});
			if (result.status === 200) {
				showNotificationSuccess({
					content: t(
						'patientTreatment.profile.askForPermission.successMessage',
					),
				});
			}
		} catch (e) {
			displayError(e);
		} finally {
			setIsLoading(false);
		}
	};

	if (isConsentProvided) {
		return <></>;
	}

	return (
		<LinkButton
			title='patientTreatment.profile.askForPermission.title'
			theme={Theme.BLUE}
			onClick={handleAskForPermission}
		/>
	);
};

export default PatientConsentRequestButton;
